import { Component, HostListener, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import {GridComponent, SearchSettingsModel, GridColumnModel, ExcelExportProperties, FilterService, InfiniteScrollService, PageService} from '@syncfusion/ej2-angular-grids';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { gridNames } from '../../../../shared/models/grid.model';
import { getCurrentDate } from '../../../../shared/models/utils/date-functions';
import {getExcelDataSource, updateFilterIcon, gridActionBeginForFilteringOdataV4, gridActionsForFiltering, excelQueryCellInfo, applyInfiniteGridTotalCount, bindInfiniteScrollPrefetch} from '../../../../shared/models/utils/grid-functions';
import { CommonService } from '../../../../shared/services/common.service';
import { UPGeneralFields } from '../../model/user-profile.model';
import { UserProfileService } from '../../services/user-profile.service';
import { Applications, RolePermissionsModel } from '../../../../shared/models/app.model';
import { GridPersistRequests, UserRoles } from '../../../../shared/constants/app.constants';
import { DirectReportsComponent } from './direct-reports/direct-reports.component';
import { MatDialog } from '@angular/material/dialog';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';

let MASTER_API_URL = '';

@Component({
    selector: 'app-users-sales',
    templateUrl: './users.component.html',
    styleUrl: './users.component.scss',
    providers: [FilterService, InfiniteScrollService, PageService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersComponent implements OnInit {
  salesGridName = gridNames.salesUsersGrid;
  serviceGridName = gridNames.serviceUsersGrid;
  gridHeight: number = window.innerHeight - 300;
  userProfile: any;
  usersGrid!: GridComponent;
  UPGeneralFields: typeof UPGeneralFields = UPGeneralFields;
  @ViewChild('columnChooser') columnChooser: any;
  showUserProfilePopup: boolean = false;
  userProfiles: DataManager = null;
  
  profileData: any;
  showGrid: boolean = false;
  query!: Query;
  serviceSearchSettings?: SearchSettingsModel = {
    fields: [
      UPGeneralFields.userId,
      'employeeId',
      UPGeneralFields.name,
      'role',
      'mobile',
      'email',
      'serviceManager'
    ]
  };
  salesSearchSettings?: SearchSettingsModel = {
    fields: [
      UPGeneralFields.userId,
      'employeeId',
      UPGeneralFields.name,
      'role',
      'mobile',
      'email',
      'salesManager'
    ]
  };
  PERMISSIONS: RolePermissionsModel[] = [];
  selectedTab: 'sales' | 'service';
  serviceColumns: GridColumnModel[];
  salesColumns: GridColumnModel[];

  @ViewChild('usersGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.usersGrid = gridComponent;
      this.setGridToolbar();
    }
  }
  public pageSettings: any = { pageSizes: [20, 50, 100, 500], pageSize: 200 };
  public infiniteScrollSettings: any = { enableCache: false, initialBlocks: 1, maxBlocks: 10 };
  totalRecords: number = 0;






  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.gridHeight = window.innerHeight - 300;
  }
  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    public dialog: MatDialog,
    private commonService: CommonService,
    private usersService: UserProfileService,
    private authService: AuthService
  ) { 
    MASTER_API_URL = this.config.masterApiURL;
  }

  ngOnInit(): void {
    // this.onUserClick({
    //         "userId": "USR0000021",
    //         "name": "test22 ",
    //         "email": "Qwerty123245@email.com",
    //         "applicationsList": "Sales",
    //         "mobile": "111111111111",
    //         "createdDate": "2025-12-17T06:28:48.020Z",
    //         "role": "",
    //         "status": "Active",
    //         "statusColor": "#479E47",
    //         "lastLoginDate": null,
    //         "hasDirectReports": false,
    //         "employeeId": "",
    //         "territory": "",
    //         "region": "",
    //         "district": "",
    //         "salesManager": "",
    //         "serviceManager": "",
    //         "iscCode": "",
    //         "serviceDepartment": ""
    //     })
    this.loadPermissions(true);
  }



  setGridToolbar() {
    let addIconPermissions = this.getPermission('UsersGrid_AddNewUser');
    let excelIconPermissions = this.getPermission('UsersGrid_ExcelExport');
    // addIconPermissions.visible = true;
    // addIconPermissions.enable = true;
    const addIconClass = !addIconPermissions?.enable ? 'disabled-grid-button' : '';
    const excelExportIconClass = !excelIconPermissions?.enable ? 'disabled-grid-button' : '';
    this.usersGrid.toolbar = [
      { id: 'column-chooser', template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { id: 'refresh', align: 'Right', prefixIcon: 'fas fa-redo-alt', cssClass: 'mb-1', tooltipText: 'Refresh' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: `grid-filter-icon`, tooltipText: 'Clear all Filters' }
    ] as any[];

    const SearchIndex = this.usersGrid?.toolbar.findIndex(item => item === 'Search');
    if ( excelIconPermissions?.visible && this.commonService.getUSER()?.role !== UserRoles.salesRep) {
        this.usersGrid?.toolbar.splice(SearchIndex + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `grid-add-button ${excelExportIconClass}`, tooltipText: 'Excel Export' });
    }
    if ( addIconPermissions?.visible ) {
        this.usersGrid?.toolbar.splice(SearchIndex + 2, 0, { text: '', id: 'add-new-user', prefixIcon: 'fas fa-add', cssClass: `grid-add-button ${addIconClass}`, tooltipText: 'Add New User' });
    }
  }
  getServiceColumns() {
    let commands = [{ title: 'Edit User', buttonOption: { iconCss: `fas fa-pencil-alt`, cssClass: 'e-flat' } }];
    if (this.getPermission('UsersGrid_ResetUserPersistence')?.visible) {
      commands.push({ title: 'Reset Persistence', buttonOption: { iconCss: `fas fa-sync linked-items`, cssClass: `e-flat linked-items` } });
    }
    if (this.getPermission('UsersGrid_ResetUserPersistence')?.visible) {
      commands.push({ title: 'Direct Reports', buttonOption: { iconCss: `fa fa-sitemap direct-reports`, cssClass: `e-flat direct-reports` } });
    }
    if (this.getPermission('UsersGrid_MarkUserActive')?.visible || true) {
      commands.push({ title: 'Mark Active', buttonOption: { iconCss: `fas fa-check-circle color-green mark-active`, cssClass: `e-flat mark-active` } });
    }
    if (this.getPermission('UsersGrid_MarkUserInactive')?.visible || true) {
      commands.push({ title: 'Mark Inactive', buttonOption: { iconCss: `fas fa-ban color-red mark-inactive`, cssClass: `e-flat mark-inactive` } });
    }

    
    let columns: GridColumnModel[] = [
      { field: UPGeneralFields.userId, headerText: UPGeneralFields.userIdDesc, allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 130, isPrimaryKey: true, showInColumnChooser: true },
      { field: 'employeeId', headerText: "Employee Id", type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: UPGeneralFields.name, headerText: UPGeneralFields.nameDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'status', headerText: 'Status', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'role', headerText: "Role", type: 'string', allowEditing: false, filter: {type: 'Excel'}, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'mobile', headerText: UPGeneralFields.mobileDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 150, visible: true, showInColumnChooser: true },
      { field: 'email', headerText: UPGeneralFields.emailDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true,  showInColumnChooser: true },
      { field: UPGeneralFields.createdDate, headerText: UPGeneralFields.createdDateDesc, type: 'date', format: { type: 'date', format: 'd MMM, y' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'serviceDepartment', headerText: "Service Department", filter: {type: 'Excel'}, type: 'string', allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
      { field: 'serviceManager', headerText: "Manager", filter: {type: 'Excel'}, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'iscCode', headerText: "ISC Code", type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      // { field: 'lastLogin', headerText: 'Last Login', type: 'datetime', format: { type: 'datetime', format: 'd MMM, y hh:mm a' }, allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
      {
        field: 'Actions', headerText: 'Actions', showInColumnChooser: false, width: 170, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
        commands
      }
    ];
    const iscCodeIndex = columns.findIndex(col => col.field === 'iscCode');
    iscCodeIndex !== -1 && [UserRoles.klNationalMGR, UserRoles.klServiceManager].includes(this.commonService.getUSER()?.role!) && columns.splice(iscCodeIndex,1);

    this.serviceSearchSettings = { fields: [ ...columns.map(x => x.type != 'date' && x.field) ].filter(
      f => !['Actions', 'status', false].includes(f)
    )};
    return columns;
  }
  getSalesColumns() {
    let commands = [{ title: 'Edit User', buttonOption: { iconCss: `fas fa-pencil-alt`, cssClass: 'e-flat' } }];
    if (this.getPermission('UsersGrid_ResetUserPersistence')?.visible) {
      commands.push({ title: 'Reset Persistence', buttonOption: { iconCss: `fas fa-sync linked-items`, cssClass: `e-flat linked-items` } });
    }
    if (this.getPermission('UsersGrid_ResetUserPersistence')?.visible) {
      commands.push({ title: 'Direct Reports', buttonOption: { iconCss: `fa fa-sitemap direct-reports`, cssClass: `e-flat direct-reports` } });
    }
    if (this.getPermission('UsersGrid_MarkUserActive')?.visible || true) {
      commands.push({ title: 'Mark Active', buttonOption: { iconCss: `fas fa-check-circle color-green mark-active`, cssClass: `e-flat mark-active` } });
    }
    if (this.getPermission('UsersGrid_MarkUserInactive')?.visible || true) {
      commands.push({ title: 'Mark Inactive', buttonOption: { iconCss: `fas fa-ban color-red mark-inactive`, cssClass: `e-flat mark-inactive` } });
    }
    let columns: GridColumnModel[] = [
      { field: UPGeneralFields.userId, headerText: UPGeneralFields.userIdDesc, allowEditing: false, textAlign: 'Left', allowFiltering: true, allowSorting: true, width: 130, isPrimaryKey: true, showInColumnChooser: true },
      { field: 'employeeId', headerText: "Employee Id", type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: UPGeneralFields.name, headerText: UPGeneralFields.nameDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'role', headerText: "Role", type: 'string', allowEditing: false, filter: {type: 'Excel'}, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      { field: 'status', headerText: 'Status', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'mobile', headerText: UPGeneralFields.mobileDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 150, visible: true, showInColumnChooser: true },
      { field: 'email', headerText: UPGeneralFields.emailDesc, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true,  showInColumnChooser: true },
      { field: UPGeneralFields.createdDate, headerText: UPGeneralFields.createdDateDesc, type: 'date', format: { type: 'date', format: 'd MMM, y' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'territory', headerText: 'Primary Territory', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'district', headerText: 'Primary District', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      { field: 'region', headerText: 'Primary Region', type: 'string', filter: { type: 'Excel' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true },
      // { field: 'applicationsList', headerText: "Applications", filter: {type: 'Excel'}, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      // { field: 'lastLogin', headerText: 'Last Login', type: 'datetime', format: { type: 'datetime', format: 'd MMM, y hh:mm a' }, allowEditing: false, textAlign: 'Left', width: 180, visible: true, showInColumnChooser: true },
      { field: 'salesManager', headerText: "Manager", filter: {type: 'Excel'}, type: 'string', allowEditing: false, textAlign: 'Left', width: 160, visible: true, showInColumnChooser: true },
      {
        field: 'Actions', headerText: 'Actions', showInColumnChooser: false, width: 170, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Right', allowReordering: false,
        commands
      }
    ];


    this.salesSearchSettings = { fields: [ ...columns.map(x => x.type != 'date' && x.field) ].filter(
      f => !['Actions', 'status', false].includes(f)
    )}
    return columns;
  }
  onClosePopup(e: any) {
    this.showUserProfilePopup = false;
    this.userProfile = null;
    this.showGrid = false;
    this.loadPermissions();
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      const canShowServiceTab = !!this.getPermission('UsersGrid_serviceUsersTab')?.visible;
      const canShowSalesTab = !!this.getPermission('UsersGrid_salesUsersTab')?.visible;
      
      const tab = localStorage.getItem('selectedTab_UserProfileGrid') as 'sales' | 'service' | undefined;
      
      if ((tab == 'sales' && canShowSalesTab) || (tab == 'service' && canShowServiceTab)) {
        this.selectedTab = tab;
        localStorage.setItem('selectedTab_UserProfileGrid',this.selectedTab);
      } 
      else if (canShowServiceTab) {
        this.selectedTab = 'service';
        localStorage.setItem('selectedTab_UserProfileGrid',this.selectedTab);
      }
      else if (canShowSalesTab) {
        this.selectedTab = 'sales';
        localStorage.setItem('selectedTab_UserProfileGrid',this.selectedTab);
      }
      else {
        localStorage.removeItem('selectedTab_UserProfileGrid');
      }
      resolve(true);
    });
  }
  loadPermissions(
    initData: boolean = false,
    category: string = 'usersGrid',
    subCategory: string = '',
    id: string = '',
    module: string = 'userProfile'
  ) {
    this.commonService.getRolePermission(category, subCategory, module, id).subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        // this.PERMISSIONS.map((p: RolePermissionsModel) => {
        //   p.ruleAction == 'UsersGrid_serviceUsersTab' && (p.visible = true);
        //   p.ruleAction == 'UsersGrid_salesUsersTab' && (p.visible = true);
        //   return p;
        // });
        this.updatePagePermissions().then(() => {
          if (initData) {
            this.serviceColumns = this.getServiceColumns();
            this.salesColumns = this.getSalesColumns();
          }
          this.initData();
        });
      },
      error: (err:  any) => {
        this.PERMISSIONS = [];
      }
    });
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  loadPage() {
    let gridName = gridNames.serviceUsersGrid;
    this.selectedTab == 'sales' && (gridName = gridNames.salesUsersGrid);
    const appId = this.commonService.getUSER()?.appId as string;
    const app = appId.includes('Service') ? Applications.RimsService : Applications.RimsSales;
    this.commonService.getPersistence(gridName, '', app)
    .subscribe({
      next: (res: any) => {
        if (res && res.result && res.result.length && res.result[0].value) {
        localStorage.setItem(`grid${gridName}`, res.result[0].value);
      } else {
        localStorage.removeItem(`grid${gridName}`);
      }
      setTimeout(() => {
        this.showGrid = true;
      }, 100);
    },
    error: (err) => {
      this.showGrid = true;
      this.commonService.showNotification("error", err?.error?.message);
    }
    });
  }
  initData() {
    this.query = new Query().addParams('appName', this.selectedTab);
    this.userProfiles = new DataManager({
      url: `${MASTER_API_URL}odata/UserProfile`,
      adaptor: new ODataV4Adaptor(),
      headers: [{ "Authorization": `Bearer ${this.authService.getToken()}` }]
    });
    setTimeout(() => {
      this.loadPage();
    }, 150);
  }


  onRowDataBound(args: any) {
    const data = args.data;
    const $row = args.row;

    const resetPersistencePermission = this.getPermission('UsersGrid_ResetUserPersistence');
    // const markUserActivePermission = this.getPermission('UsersGrid_MarkUserActive'); // to be removed as these are unnecessary permissions
    // const markUserInactivePermission = this.getPermission('UsersGrid_MarkUserInactive');// to be removed as these are unnecessary permissions
    if (resetPersistencePermission?.enable) {
      $row.getElementsByClassName('linked-items')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('linked-items')[0]?.classList.add('disabled-grid-button');
    }
    if (resetPersistencePermission?.enable && data?.applicationsList?.length) {
      $row.getElementsByClassName('direct-reports')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('direct-reports')[0]?.classList.add('disabled-grid-button');
    }
    if (data?.status == "Inactive") {
      $row.getElementsByClassName('mark-active')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('mark-active')[0]?.classList.add('disabled-grid-button');
    }
    if (data?.status == "Active") {
      $row.getElementsByClassName('mark-inactive')[0]?.classList.remove('disabled-grid-button');
    } else {
      $row.getElementsByClassName('mark-inactive')[0]?.classList.add('disabled-grid-button');
    }
  }

  onExcelQueryCellInfo(args: any) {
    excelQueryCellInfo(args);
  }

  onToolbarClick(args: any) {
    if (args.item.id === 'add-new-user') {
      this.userProfile = {};
      this.showUserProfilePopup = true;
    } else if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.usersGrid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `User Profiles (${getCurrentDate()}).xlsx`
      };
      this.usersGrid?.excelExport(excelExportProperties);
    } else if (args.item.id === 'refresh') {
      this.loadPermissions();
    } else if (args.item.id === 'clear-filter') {
        this.clearAllFilters();
    }
  }
  updatePersistence(userId: string = '', value: any = '', appName: Applications.RimsSales | Applications.RimsService | '' = Applications.RimsSales) {
    let gridName = gridNames.serviceUsersGrid;
    this.selectedTab == 'sales' && (gridName = gridNames.salesUsersGrid);
    this.commonService.savePersistence({ userId, name: gridName, value, appId: appName })
    .subscribe((res: any) => {
      localStorage.setItem(`grid${gridName}`, value ?? this.usersGrid?.getPersistData());
    });
  }

  onCommandClick(args: any) {
    let rowData = args.rowData;
    if (args.commandColumn.title === 'Reset Persistence') {
      this.commonService.showConfirmation('This will clear the persistence of this user, Do you want to proceed?')
        .then(result => {
          if (result.isConfirmed) {
            this.usersService.clearPersistence(rowData[UPGeneralFields.userId], '')
            .subscribe({
              next: (res: any) => {
                this.commonService.showNotification('info', res.message);
              },
              error: (err: any) => {
                this.commonService.showNotification('error', err?.error?.message);
              },
            });
          }
        });
    }
    else if (args.commandColumn.title === 'Edit User') {
      this.showUserProfilePopup = true;
      this.userProfile = rowData;
    }
    else if (args.commandColumn.title === 'Direct Reports') {
      this.showDirectReportsPopup(rowData);
    }
    else if (args.commandColumn.title === 'Mark Inactive') {
      this.commonService.showConfirmation(`Are you sure to disable ${args?.rowData?.name}?`)
      .then((res: any) => {
        if(res?.isConfirmed) {
          this.enableDisableApp(args?.rowData?.userId, false, this.selectedTab == 'service' ? Applications.RimsService : Applications.RimsSales);
        }
      })
    }
    else if (args.commandColumn.title === 'Mark Active') {
      this.enableDisableApp(args?.rowData?.userId, true, this.selectedTab == 'service' ? Applications.RimsService : Applications.RimsSales);
    }
  }
  showDirectReportsPopup(data: any) {
      const dialogRef = this.dialog.open(DirectReportsComponent, {
        disableClose: false,
        maxWidth: '720px',
        maxHeight: '520px',
        width: '100%',
        height: '100%',
        enterAnimationDuration: '0',
        exitAnimationDuration: '0',
        data: {
          app: data?.applicationsList,
          userId: data?.[UPGeneralFields.userId]
         },
      });

      dialogRef.afterClosed().subscribe((result) => {
      });
  }


  enableDisableApp(userId: string, toggle: boolean, app: Applications) {
    this.usersService.enableDisableApplication(userId, app, toggle).subscribe({
      next:(res: any) => {
        this.usersGrid.refresh();
        this.commonService.showNotification("success", res?.message);
      },
      error: (err: any) => {
        this.commonService.showNotification("error", err?.error?.message);
      }
    });
  }
  onGridCreated(event: any) {
    updateFilterIcon({ requestType: 'filtering' }, this.usersGrid);
    bindInfiniteScrollPrefetch(this.usersGrid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
}

  onGridActionBegin(args: any, grid?: any) {
    gridActionBeginForFilteringOdataV4(args);
    if (args.requestType === 'infiniteScroll') setTimeout(() => this.usersGrid?.hideSpinner());
}

  onGridActionComplete(args: any, grid: any) {
    if (args.requestType === 'infiniteScroll') {
      setTimeout(() => grid?.hideSpinner());
    }

    gridActionsForFiltering(args, grid);
    if (!grid.searchSettings['properties'].key && grid.filterSettings.columns && grid.filterSettings.columns.length && grid.filterSettings.columns.findIndex((col: any) => col['properties'].field !== 'technicianId') === -1) {
      document.getElementById(grid.element.id)?.getElementsByClassName('grid-filter-icon')[0]?.classList.remove('filtered');
    } else {
      updateFilterIcon(args, grid);
    }
    if (GridPersistRequests.includes(args.requestType)) {
    const appId = this.commonService.getUSER()?.appId as string;
    const app = appId.includes('Service') ? Applications.RimsService : Applications.RimsSales;
      this.updatePersistence('', this.usersGrid?.getPersistData(), app);
    }
    applyInfiniteGridTotalCount(grid, (count) => { this.totalRecords = count; }, args.requestType, args);
}

  tabClick(tab: 'sales' | 'service') {
    // this.clearAllFilters();
    this.selectedTab = tab;
    localStorage.setItem('selectedTab_UserProfileGrid', this.selectedTab);
    this.initData();
    // this.query.addParams('appName', this.selectedTab);
    // this.showGrid = false;
    // setTimeout(() => {
    //   this.showGrid = true;
    // }, 250);
    // this.usersGrid.refresh();
    if (tab === 'sales') {
      
    } else if (tab === 'service'){

    }
  }
  clearAllFilters() {
    this.usersGrid?.clearFiltering();
    this.usersGrid?.clearSorting();
    this.usersGrid?.search('');
    const appId = this.commonService.getUSER()?.appId as string;
    const app = appId.includes('Service') ? Applications.RimsService : Applications.RimsSales;
    this.updatePersistence('', '', app); // clears persistence
    this.usersGrid?.refresh();
  }
  onUserClick(data: any) {
    this.showUserProfilePopup = true;
    this.userProfile = data;
  }


  onDataBound() {
    bindInfiniteScrollPrefetch(this.usersGrid, () => this.totalRecords, 0, (count) => { this.totalRecords = count; });
  }

}


